/**
 * จัดกลุ่มรอบหวยตาม section — ตรง user-classic lotteryResultSectionUtils
 */
import type { LotteryRound } from '../services/lotteryService'

export function isEgovRound(round: LotteryRound): boolean {
  const combined = (round.huayName || '') + (round.huayTypeName || '')
  return /ธ\.?\s*ก\.?\s*ส\.?|ธกส|egov/i.test(combined)
}

export function isGsbRound(round: LotteryRound): boolean {
  const combined = (round.huayName || '') + (round.huayTypeName || '')
  return /ออมสิน|gsb/i.test(combined)
}

export function isGovernmentLottery(round: LotteryRound): boolean {
  const huayName = (round.huayName || '').toLowerCase()
  const typeName = (round.huayTypeName || '').toLowerCase()
  if (huayName.includes('ชุด')) return false
  return huayName.includes('รัฐบาล') || huayName.includes('หวยรัฐบาล') || typeName.includes('รัฐบาล')
}

export function isThaiGovernmentLotteryOnly(round: LotteryRound): boolean {
  if (!isGovernmentLottery(round)) return false
  const combined = (round.huayName || '') + (round.huayTypeName || '')
  if (/ธ\.?\s*ก\.?\s*ส\.?|ธกส|ออมสิน|egov|gsb/i.test(combined)) return false
  if (/รัฐบาลไทย|หวยรัฐบาลไทย|หวยรัฐบาล/.test(combined)) return true
  if ((round.roundNumber || '').toUpperCase().startsWith('LGV')) return true
  return false
}

export function isSetLottery(round: LotteryRound): boolean {
  const typeName = (round.huayTypeName || '').toLowerCase()
  const huayName = (round.huayName || '').toLowerCase()
  const combined = typeName + huayName
  return /หวยชุด|เลขชุด|ชุด/.test(combined)
}

export function isYeekeeRound(round: LotteryRound): boolean {
  const name = (round.huayTypeName || '') + (round.huayName || '') + (round.roundNumber || '') + (round.huayTypeCode || '')
  return /ยี่กี|ยี|yeekee/i.test(name)
}

export function isYeekeeVipRound(round: LotteryRound): boolean {
  const combined = (
    (round.huayName || '') +
    (round.huayTypeName || '') +
    (round.roundNumber || '') +
    (round.huayTypeCode || '')
  ).toLowerCase()
  return /ยี่กี|ยีกี่|ยี|yeekee/i.test(combined) && /vip|วีไอพี/i.test(combined)
}

export type SectionKind =
  | 'yeekee'
  | 'government'
  | 'set'
  | 'simple'
  | 'thai_stock'
  | 'foreign'
  | 'foreign_stock'
  | 'other'

export function getSectionKind(round: LotteryRound): SectionKind {
  if (isYeekeeRound(round)) return 'yeekee'
  if (isGovernmentLottery(round)) return 'government'
  if (isSetLottery(round)) return 'set'
  const typeName = (round.huayTypeName || '').toLowerCase()
  const name = (round.huayName || '').toLowerCase()
  if (typeName.includes('หุ้นไทย') || name.includes('หุ้นไทย')) return 'thai_stock'
  if (typeName.includes('หุ้นต่างประเทศ') || name.includes('หุ้นต่างประเทศ')) return 'foreign_stock'
  if (typeName.includes('หุ้น') || name.includes('หุ้น')) return 'foreign_stock'
  if (
    typeName.includes('ต่างประเทศ') ||
    /ลาว|มาเลย์|ฮานอย|เวียดนาม|กัมพูชา/i.test(typeName + name)
  )
    return 'foreign'
  return 'simple'
}

/** ดึงค่า id จาก huayTypeId ที่อาจเป็น string หรือ object (จาก API ที่ populate แล้ว) */
function normalizeHuayTypeId(value: unknown): string {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'object' && value !== null && '_id' in value)
    return String((value as { _id?: unknown })._id ?? '')
  return String(value)
}

export function roundMatchesHuayType(
  round: LotteryRound,
  huayType: { _id?: string; huayTypeId?: string; name?: string; code?: string }
): boolean {
  const tabId = String(huayType.huayTypeId ?? huayType._id ?? '')
  const roundTypeId = normalizeHuayTypeId(round.huayTypeId)
  if (roundTypeId && tabId && roundTypeId === tabId) return true
  if (round.huayTypeName && huayType.name && String(round.huayTypeName).trim() === String(huayType.name).trim())
    return true
  if (
    round.huayTypeCode &&
    huayType.code &&
    String(round.huayTypeCode).toUpperCase() === String(huayType.code).toUpperCase()
  )
    return true
  return false
}
